"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var UPWARDS = 'up';
var DOWNWARDS = 'down';
var UNPINNED = 'unpinned';
var PINNED = 'pinned';
var STATIC = 'static';
var NO_TRANSITION = 'none';
var NORMAL_TRANSITION = 'normal';
var PINNED_TO_STATIC = 'pinned-to-static';
var HeaderWrapper = _styledComponents.default.div.withConfig({
  displayName: "Headroom__HeaderWrapper",
  componentId: "sc-16d3zk-0"
})(["position:", ";top:", "px;z-index:", ";transform:translateY(", "px);animation-duration:0.2s;animation-timing-function:ease-out;", " ", " ", ""], function (props) {
  return props.positionStickyDisabled ? 'static' : 'sticky';
}, function (props) {
  return props.top;
}, function (props) {
  return props.zIndex;
}, function (props) {
  return props.translateY;
}, function (props) {
  return props.transition === NORMAL_TRANSITION && !props.static ? 'transition: transform 0.2s ease-out;' : '';
}, function (props) {
  return props.transition === PINNED_TO_STATIC ? (0, _styledComponents.css)(["animation-name:", ";"], keyframesMoveUpFrom(props.animateUpFrom)) : '';
}, function (props) {
  return props.static ? 'transition: none;' : '';
});
var keyframesMoveUpFrom = function keyframesMoveUpFrom(from) {
  return (0, _styledComponents.keyframes)(["from{transform:translateY(", "px)}to{transform:translateY(0)}"], Math.max(from, 0));
};
var Headroom = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Headroom, _React$PureComponent);
  var _super = _createSuper(Headroom);
  function Headroom() {
    var _this;
    _classCallCheck(this, Headroom);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      mode: STATIC,
      transition: NO_TRANSITION,
      animateUpFrom: null
    });
    _defineProperty(_assertThisInitialized(_this), "lastKnownScrollTop", 0);
    _defineProperty(_assertThisInitialized(_this), "update", function () {
      var currentScrollTop = _this.getScrollTop();
      var newState = {};
      if (currentScrollTop === _this.lastKnownScrollTop) {
        return;
      }
      var direction = _this.lastKnownScrollTop < currentScrollTop ? DOWNWARDS : UPWARDS;
      newState.mode = _this.determineMode(currentScrollTop, direction);
      newState.transition = _this.determineTransition(newState.mode, direction);
      var _this$props = _this.props,
        onStickyTopChanged = _this$props.onStickyTopChanged,
        height = _this$props.height,
        scrollHeight = _this$props.scrollHeight,
        pinStart = _this$props.pinStart;
      if (_this.state.mode === PINNED && newState.mode === STATIC) {
        // animation in the special case from pinned to static
        newState.animateUpFrom = currentScrollTop - pinStart;
      }
      if (onStickyTopChanged && newState.mode !== _this.state.mode && height) {
        onStickyTopChanged(Headroom.calcStickyTop(newState.mode, height, scrollHeight));
      }
      _this.setState(newState);
      _this.lastKnownScrollTop = currentScrollTop;
    });
    _defineProperty(_assertThisInitialized(_this), "handleEvent", function () {
      window.requestAnimationFrame(_this.update);
    });
    return _this;
  }
  _createClass(Headroom, [{
    key: "getScrollTop",
    value:
    /**
     * @returns {number} the current scrollTop position of the window
     */
    function getScrollTop() {
      var parent = this.props.parent;
      if (parent && parent.scrollTop !== undefined && parent !== document.documentElement) {
        return parent.scrollTop;
      }
      if (parent !== document.documentElement) {
        console.warn('Could not find parent for StickyHeadroom. Defaulting to window, documentElement or body.');
      }
      if (window.pageYOffset !== undefined) {
        return window.pageYOffset;
      } else if (window.scrollTop !== undefined) {
        return window.scrollTop;
      } else if (document.documentElement) {
        return document.documentElement.scrollTop;
      } else if (document.body) {
        return document.body.scrollTop;
      } else {
        throw new Error('Could not determine scrollTop!');
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.addScrollListener(this.props.parent);
    }
  }, {
    key: "addScrollListener",
    value: function addScrollListener(parent) {
      if (parent === window.document.documentElement) {
        window.addEventListener('scroll', this.handleEvent);
      } else if (parent) {
        parent.addEventListener('scroll', this.handleEvent);
      } else {
        console.debug('Property parent of Headroom is null. Assuming, parent will be set soon...');
      }
    }
  }, {
    key: "removeScrollListener",
    value: function removeScrollListener(parent) {
      if (parent === window.document.documentElement) {
        window.removeEventListener('scroll', this.handleEvent);
      } else if (parent) {
        parent.removeEventListener('scroll', this.handleEvent);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.parent !== this.props.parent) {
        this.removeScrollListener(prevProps.parent);
        this.addScrollListener(this.props.parent);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeScrollListener(this.props.parent);
    }

    /**
     * If we're already static and pinStart + scrollHeight >= scrollTop, then we should stay static.
     * If we're not already static, then we should set the header static, only when pinStart >= scrollTop (regardless of
     * scrollHeight, so the header doesn't jump up, when scrolling upwards to the trigger).
     * Else we shouldn't set it static.
     * @param scrollTop the currentScrollTop position
     * @param direction the current direction
     * @returns {boolean} if we should set the header static
     */
  }, {
    key: "shouldSetStatic",
    value: function shouldSetStatic(scrollTop, direction) {
      if (this.state.mode === STATIC || this.state.mode === PINNED && direction === DOWNWARDS) {
        return this.props.pinStart + this.props.scrollHeight >= scrollTop;
      } else {
        return this.props.pinStart >= scrollTop;
      }
    }

    /**
     * Determines the mode depending on the scrollTop position and the current direction
     * @param {number} scrollTop
     * @param {string} direction
     * @returns {string} the next mode of Headroom
     */
  }, {
    key: "determineMode",
    value: function determineMode(scrollTop, direction) {
      if (this.shouldSetStatic(scrollTop, direction)) {
        return STATIC;
      } else {
        return direction === UPWARDS ? PINNED : UNPINNED;
      }
    }

    /**
     * @returns {TransitionType} determines the kind of transition
     */
  }, {
    key: "determineTransition",
    value: function determineTransition(mode, direction) {
      // Handle special case: If we're pinned and going to static, we need a special transition using css animation
      if (this.state.mode === PINNED && mode === STATIC) {
        return PINNED_TO_STATIC;
      }
      // If mode is static, then no transition, because we're already in the right spot
      // (and want to change transform and top properties seamlessly)
      if (mode === STATIC) {
        return this.state.transition === NO_TRANSITION ? NO_TRANSITION : PINNED_TO_STATIC;
      }
      // mode is not static, transition when moving upwards or when we've lastly did the transition
      return direction === UPWARDS || this.state.transition === NORMAL_TRANSITION ? NORMAL_TRANSITION : NO_TRANSITION;
    }

    /**
     * Checks the current scrollTop position and updates the state accordingly
     */
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        children = _this$props2.children,
        scrollHeight = _this$props2.scrollHeight,
        positionStickyDisabled = _this$props2.positionStickyDisabled,
        zIndex = _this$props2.zIndex,
        className = _this$props2.className;
      var _this$state = this.state,
        mode = _this$state.mode,
        transition = _this$state.transition,
        animateUpFrom = _this$state.animateUpFrom;
      var transform = mode === UNPINNED ? -scrollHeight : 0;
      var ownStickyTop = mode === STATIC ? -scrollHeight : 0;
      return /*#__PURE__*/React.createElement(HeaderWrapper, {
        className: className,
        translateY: transform,
        top: ownStickyTop,
        transition: transition,
        positionStickyDisabled: positionStickyDisabled,
        static: mode === STATIC,
        animateUpFrom: animateUpFrom,
        zIndex: zIndex
      }, children);
    }
  }], [{
    key: "calcStickyTop",
    value: function calcStickyTop(mode, height, scrollHeight) {
      return mode === PINNED ? height : height - scrollHeight;
    }
  }]);
  return Headroom;
}(React.PureComponent);
_defineProperty(Headroom, "defaultProps", {
  pinStart: 0,
  zIndex: 1,
  parent: window.document.documentElement
});
var _default = Headroom;
exports.default = _default;